import React from 'react';
import { motion, Variants } from 'framer-motion';
import Constants from '../../../app/utils/constants';
import colors from '../../theme/color';

const SolutionSection = () => {
  const { arbventureSolution } = Constants;

  const leftVariant: Variants = {
    hidden: { opacity: 0, x: -150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.7, ease: 'easeIn' },
    },
  };

  const rightVariant: Variants = {
    hidden: { opacity: 0, x: 150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.7, ease: 'easeIn' },
    },
  };

  return (
    <section className="relative overflow-hidden pt-8 md:pt-10 px-5">
      <div className="mx-auto w-full text-center xl:max-w-[1320px] 2xl:max-w-[85%] min-[2560px]:max-w-[2100px] ">

        {/* BADGE — continuously pulses */}
        <motion.div
          className="inline-flex items-center justify-center px-6 py-3 lg:px-7 lg:py-3.5 2xl:px-9 2xl:py-4 min-[2560px]:px-12 min-[2560px]:py-6"
          style={{ backgroundColor: colors.arbVentureAccent }}
        >
          <span className="font-gilroy-bold text-[2rem] font-semibold leading-none text-white lg:text-[2.35rem] xl:text-[2.7rem] 2xl:text-[3.25rem] min-[2056px]:text-[3.8rem] min-[2560px]:text-[4.8rem]">
            {arbventureSolution.badgeText}
          </span>
        </motion.div>

        <p className="mx-auto mt-5 font-gilroy-medium opacity-[80%] text-[1.05rem] leading-[1.5] md:text-[1.16rem] lg:max-w-[920px] lg:text-[1.2rem] xl:text-[1.2rem] 2xl:max-w-[90%] 2xl:text-[1.78rem] min-[2560px]:max-w-[1500px] min-[2560px]:text-[2.6rem] min-[2560px]:mt-10">
          {arbventureSolution.description}
        </p>

        {/* GRID — left col from left, right col from right */}
        <div className="mx-auto mt-8 grid grid-cols-1 gap-4 text-left md:grid-cols-2 md:gap-x-7 md:gap-y-5 xl:max-w-[1160px] 2xl:max-w-full 2xl:gap-x-9 2xl:gap-y-6 min-[2560px]:max-w-[1800px] min-[2560px]:gap-x-14 min-[2560px]:gap-y-10 min-[2560px]:mt-14">
          {arbventureSolution.items.map((item, i) => {
            const isLeftCol = i % 2 === 0;

            return (
              <motion.div
                key={item}
                variants={isLeftCol ? leftVariant : rightVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                className="relative flex items-center rounded-full border-[1.2px] border-transparent px-4 py-3 shadow-[0_14px_28px_rgba(0,0,0,0.16)] transition-all duration-300 w-full  md:justify-self-start md:px-5  2xl:px-8 2xl:py-4.5 min-[2560px]:w-[51rem] min-[2560px]:border-[2.5px] min-[2560px]:px-12 min-[2560px]:py-8"
                style={{
                  background: 'linear-gradient(90deg, rgba(25, 33, 26, 0.95) 0%, rgba(18, 24, 19, 0.92) 85%, rgba(10, 7, 5, 0.3) 100%) padding-box, linear-gradient(90deg, rgba(111, 175, 56, 0.4) 0%, rgba(111, 175, 56, 0.1) 85%, rgba(111, 175, 56, 0) 90%) border-box',
                }}
              >
                <div className="flex h-1 w-1 shrink-0 rounded-full bg-white md:h-1.5 md:w-1.5 min-[2560px]:h-3 min-[2560px]:w-3" aria-hidden="true" />
                <span className="ml-3 py-1 font-gilroy-medium text-[0.9rem] leading-[1.2] text-white lg:text-[0.98rem] xl:text-[1.06rem] 2xl:ml-4 2xl:py-1.5 2xl:text-[1.5rem] min-[2560px]:ml-6 min-[2560px]:py-2 min-[2560px]:text-[2rem]">
                  {item}
                </span>
              </motion.div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default SolutionSection;